module.exports = __webpack_public_path__ + "img/scan.b39042d8.svg";